import { render, staticRenderFns } from "./SubmissionGroups.vue?vue&type=template&id=1eb4c910"
import script from "./SubmissionGroups.vue?vue&type=script&lang=js"
export * from "./SubmissionGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports